import fetch from '@/utils/fetch'
import {
  delVideoURI,
  timerPubVideoURI,
  pubVideoURI,
  dePubVideoURI,
  getVideoListURI,
  delTimerPubVideoURI,
  getVideoLogsURI,
} from './urls'

/**
 * 获取用户视频列表
 * @param params {
 *  id 视频主键id  n
 *  uuid 用户uuid y
 *  title 标题 n
 *  checkState 视频状态 n
 *  pageNo 页码
 *  pageSize 每页条数
 * }
 */
export function fetchVideos(params: any): Promise<any> {
  return fetch.get(getVideoListURI, { params: params })
}

/**
 * 删除视频
 * @param ids 需要删除的id用英文,号隔开
 */
export function delVideo(ids: string): Promise<any> {
  return fetch.get(delVideoURI, { params: { ids: ids } })
}

/**
 * 定时发布视频
 * @param params {
 *  id 视频主键id,
 *  timerTime 定时发布的时间
 * }
 */
export function timerPubVideo(params: any): Promise<any> {
  return fetch.get(timerPubVideoURI, { params: params })
}

/**
 * 发布视频
 * @param id 视频主键id
 */
export function pubVideo(id: number): Promise<any> {
  return fetch.get(pubVideoURI, { params: { id: id } })
}

/**
 * 取消发布(下线)视频
 * @param ids 需要删除的id用英文,号隔开
 */
export function dePubVideo(ids: string): Promise<any> {
  return fetch.get(dePubVideoURI, { params: { ids: ids } })
}

/**
 * 取消定时发布
 * @param id 视频主键id
 */
export function deTimerPubVideo(id: number): Promise<any> {
  return fetch.get(delTimerPubVideoURI, { params: { id: id } })
}

/**
 * .查看不通过原因
 * @param id 视频主键id,
 * @param reasonType 类型 固定为1
 * }
 */
export function getVideoLogs(id: number, reasonType = 1): Promise<any> {
  return fetch.get(getVideoLogsURI, {
    params: { id: id, reasonType: reasonType },
  })
}
